import axios from "axios";
import { api_url } from "../config";

const base_url = api_url;

export const getWarehouses = async (limit, page) => {
  return axios.get(`${base_url}/dashboard/warehouses/list`, {
    withCredentials: true,
    params: {
      limit,
      page
    }
  });
};
